<template>
  <div class="subaccount-page dark-theme">
    <!-- 主内容区 -->
    <div class="subaccount-container">
      <!-- 卡片：搜索和添加 -->
      <div class="section-card">
        <div class="card-header">
          <a-icon type="user" class="card-icon" />
          <h3 class="card-title">{{ translate('subaccount.title') }}</h3>
        </div>
        
        <div class="search-add-section">
          <a-form
            :model="formData"
            @submit.prevent="onSubmit"
            layout="inline"
            class="search-form"
          >
            <a-form-item name="uname">
              <a-input
                v-model="formData.uname"
                :placeholder="translate('subaccount.search.placeholder')"
                style="min-width: 300px"
                allow-clear
                @pressEnter="onSubmit"
                class="dark-input"
              />
            </a-form-item>
            <a-form-item>
              <a-button type="primary" @click="onSubmit" class="action-btn">{{ translate('subaccount.search.button') }}</a-button>
            </a-form-item>
          </a-form>
          
          <div class="add-btn-container">
            <a-button type="primary" @click="showAllocateModal" class="generate-button">{{ translate('subaccount.add.button') }}</a-button>
          </div>
        </div>
        
        <!-- 流量统计 -->
        <div class="flow-stats-grid">
          <div class="flow-stat-item">
            <div class="stat-label">{{ translate('subaccount.flow.master.available') }}</div>
            <div class="stat-value">{{ Number(masterInfo.flow) - Number(masterInfo.consumeFlow) }}GB</div>
          </div>
          <div class="flow-stat-item">
            <div class="stat-label">{{ translate('subaccount.flow.son.total') }}</div>
            <div class="stat-value">{{ sonFlow.toFixed(2) }}GB</div>
          </div>
          <div class="flow-stat-item">
            <div class="stat-label">{{ translate('subaccount.flow.son.available') }}</div>
            <div class="stat-value">{{ sonFlowCanUse.toFixed(2) }}GB</div>
          </div>
        </div>
      </div>
      
      <!-- 子账号列表 -->
      <div class="section-card">
        <div class="card-header">
          <a-icon type="table" class="card-icon" />
          <h3 class="card-title">{{ translate('subaccount.title') }}</h3>
        </div>
        
        <a-table
          :columns="columns"
          :data-source="datalist"
          rowKey="nodeId"
          :loading="dataLoading"
          :scroll="{ x: 1300 }"
          size="middle"
          class="custom-table dark-table"
        >
          <!-- 操作列 -->
          <template slot="action" slot-scope="text, record">
            <a-space size="small">
              <a-button type="primary" size="small" @click="handleClickadd(record)" class="table-btn primary-btn">{{ translate('subaccount.action.add.flow') }}</a-button>
              <a-button size="small" @click="handleClickdeduct(record)" class="table-btn secondary-btn">{{ translate('subaccount.action.deduct.flow') }}</a-button>
              <a-button danger size="small" @click="changeword(record)" class="table-btn danger-btn">{{ translate('subaccount.action.delete') }}</a-button>
              <a-button size="small" @click="edit(record)" class="table-btn info-btn">{{ translate('subaccount.action.edit.remark') }}</a-button>
            </a-space>
          </template>
        </a-table>
      </div>
    </div>
    
    <!-- 添加子账号模态框 -->
    <a-modal
      :visible.sync="visiblefp"
      :title="translate('subaccount.modal.add.title')"
      @ok="onflewform"
      @cancel="onCloseform"
      class="dark-modal"
    >
      <a-form :model="cutflewform" layout="vertical" class="dark-form">
        <a-form-item :label="translate('subaccount.modal.add.flow.label')">
          <a-input v-model="cutflewform.flow" :placeholder="translate('subaccount.modal.add.flow.placeholder')" class="dark-input" />
        </a-form-item>
        <a-form-item :label="translate('subaccount.modal.add.username.label')">
          <a-input v-model="cutflewform.sonname" :placeholder="translate('subaccount.modal.add.username.placeholder')" class="dark-input" />
        </a-form-item>
        <a-form-item :label="translate('subaccount.modal.add.password.label')">
          <a-input v-model="cutflewform.password" :placeholder="translate('subaccount.modal.add.password.placeholder')" class="dark-input" />
        </a-form-item>
      </a-form>
    </a-modal>
    
    <!-- 添加流量模态框 -->
    <a-modal
      :visible.sync="visiblenewfp"
      :title="translate('subaccount.modal.add.flow.title')"
      @ok="addflew"
      @cancel="onCloseflew"
      class="dark-modal"
    >
      <a-form :model="addflewform" layout="vertical" class="dark-form">
        <a-form-item :label="translate('subaccount.modal.add.flow.title')">
          <a-input v-model="addflewform.flow" :placeholder="translate('subaccount.modal.add.flow.input.placeholder')" class="dark-input" />
        </a-form-item>
      </a-form>
    </a-modal>
    
    <!-- 扣除流量模态框 -->
    <a-modal
      :visible.sync="visiblenewfd"
      :title="translate('subaccount.modal.deduct.flow.title')"
      @ok="dudflew"
      @cancel="onCloseflewd"
      class="dark-modal"
    >
      <a-form :model="dudflewform" layout="vertical" class="dark-form">
        <a-form-item :label="translate('subaccount.modal.deduct.flow.title')">
          <a-input v-model="dudflewform.flow" :placeholder="translate('subaccount.modal.deduct.flow.placeholder')" class="dark-input" />
        </a-form-item>
      </a-form>
    </a-modal>
    
    <!-- 编辑备注模态框 -->
    <a-modal
      :visible.sync="visibledit"
      :title="translate('subaccount.modal.edit.remark.title')"
      @ok="updateEdit"
      @cancel="onCloseEdit"
      class="dark-modal"
    >
      <a-form :model="editform" layout="vertical" class="dark-form">
        <a-form-item :label="translate('subaccount.modal.edit.remark.label')">
          <a-input v-model="editform.remark" :placeholder="translate('subaccount.modal.edit.remark.placeholder')" class="dark-input" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'SubAccount',
  inject: ['languageState'],
  computed: {
    currentLanguage() {
      return this.languageState ? this.languageState.languageCode : 'en';
    },
    columns() {
      return [
        {
          title: this.translate('subaccount.column.username'),
          dataIndex: 'username',
          key: 'username',
          width: 120,
        },
        {
          title: this.translate('subaccount.column.flow'),
          dataIndex: 'countFlow',
          key: 'countFlow',
          width: 100,
        },
        {
          title: this.translate('subaccount.column.used.flow'),
          dataIndex: 'consumeFlow',
          key: 'consumeFlow',
          width: 100,
        },
        {
          title: this.translate('subaccount.column.host'),
          dataIndex: 'ip',
          key: 'ip',
          width: 150,
        },
        {
          title: this.translate('subaccount.column.port'),
          dataIndex: 'port',
          key: 'port',
          width: 80,
        },
        {
          title: this.translate('subaccount.column.password'),
          dataIndex: 'password',
          key: 'password',
          width: 150,
        },
        {
          title: this.translate('subaccount.column.create.time'),
          dataIndex: 'createTime',
          key: 'createTime',
          width: 180,
        },
        {
          title: this.translate('subaccount.column.remark'),
          dataIndex: 'remark',
          key: 'remark',
          width: 100,
        },
        {
          title: this.translate('subaccount.column.action'),
          key: 'action',
          width: 400,
          scopedSlots: { customRender: 'action' },
        },
      ];
    },
  },
  data() {
    return {
      timer: '', // 定时器名称
      uid: localStorage.getItem("userId"),
      dataTypeList: [],
      rules: {
        sonname: [{ required: true, message: '用户名必填', trigger: 'blur' }],
        password: [{ required: true, message: '密码必填', trigger: 'blur' }],
      },
      formData: {
        uname: '',
        username: '',
        pageNum: 1,
        pageSize: 10,
      },

      cutflewform: {
        flow: '',
        password: '',
        sonname: '',
        dataType: '',
      },
      addflewform: {
        flow: '',
      },
      dudflewform: {
        flow: '',
      },
      editform: {
        remark: '',
      },
      passform: {
        password: ''
      },
      datalist: [],
      visiblefp: false,
      visiblenewfp: false,
      visiblenewfd: false,
      visibledit: false,
      dataLoading: false,
      uname: '',
      realyAccount: '',
      realyAccounts: '',
      sonAccountNames: '',
      nodeId: '',
      upids: '',
      cid: '',
      uids: '',
      value: 'first',
      // 当前编辑的行数据
      currentEditRow: null,
      masterInfo: {
        flow: 0,
        consumeFlow: 0
      },
      sonFlow: 0, // 子账号总流量
      sonFlowCanUse: 0, // 子账号剩余流量
    };
  },
  mounted() {
    this.dataLoading = true;
    this.getlist();
    // this.getTypelist();
    this.start();
  },
  methods: {
    translate(key) {
      const lang = this.currentLanguage;
      const translations = {
        'subaccount.title': lang === 'zh' ? '子账号管理' : 'Sub Account Management',
        'subaccount.search.placeholder': lang === 'zh' ? '搜索用户名' : 'Search Username',
        'subaccount.search.button': lang === 'zh' ? '搜索' : 'Search',
        'subaccount.add.button': lang === 'zh' ? '添加子账号' : 'Add Sub Account',
        'subaccount.flow.master.available': lang === 'zh' ? '主账号可分配流量' : 'Master Account Available Flow',
        'subaccount.flow.son.total': lang === 'zh' ? '子账号总流量' : 'Sub Account Total Flow',
        'subaccount.flow.son.available': lang === 'zh' ? '子账号剩余总流量' : 'Sub Account Remaining Flow',
        'subaccount.column.username': lang === 'zh' ? '用户名' : 'Username',
        'subaccount.column.flow': lang === 'zh' ? '流量' : 'Flow',
        'subaccount.column.used.flow': lang === 'zh' ? '已用流量' : 'Used Flow',
        'subaccount.column.host': lang === 'zh' ? '主机' : 'Host',
        'subaccount.column.port': lang === 'zh' ? '端口' : 'Port',
        'subaccount.column.password': lang === 'zh' ? '密码' : 'Password',
        'subaccount.column.create.time': lang === 'zh' ? '创建时间' : 'Create Time',
        'subaccount.column.remark': lang === 'zh' ? '备注' : 'Remark',
        'subaccount.column.action': lang === 'zh' ? '操作' : 'Action',
        'subaccount.action.add.flow': lang === 'zh' ? '添加流量' : 'Add Flow',
        'subaccount.action.deduct.flow': lang === 'zh' ? '扣除流量' : 'Deduct Flow',
        'subaccount.action.delete': lang === 'zh' ? '删除' : 'Delete',
        'subaccount.action.edit.remark': lang === 'zh' ? '编辑备注' : 'Edit Remark',
        'subaccount.modal.add.title': lang === 'zh' ? '添加子账号' : 'Add Sub Account',
        'subaccount.modal.add.flow.label': lang === 'zh' ? '流量' : 'Flow',
        'subaccount.modal.add.username.label': lang === 'zh' ? '用户名' : 'Username',
        'subaccount.modal.add.password.label': lang === 'zh' ? '密码' : 'Password',
        'subaccount.modal.add.flow.placeholder': lang === 'zh' ? '请输入流量' : 'Please enter flow',
        'subaccount.modal.add.username.placeholder': lang === 'zh' ? '请输入用户名' : 'Please enter username',
        'subaccount.modal.add.password.placeholder': lang === 'zh' ? '请输入密码' : 'Please enter password',
        'subaccount.modal.add.flow.title': lang === 'zh' ? '添加流量' : 'Add Flow',
        'subaccount.modal.add.flow.input.placeholder': lang === 'zh' ? '请输入添加流量' : 'Please enter add flow',
        'subaccount.modal.deduct.flow.title': lang === 'zh' ? '扣除流量' : 'Deduct Flow',
        'subaccount.modal.deduct.flow.placeholder': lang === 'zh' ? '请输入扣除流量' : 'Please enter deduct flow',
        'subaccount.modal.edit.remark.title': lang === 'zh' ? '编辑备注' : 'Edit Remark',
        'subaccount.modal.edit.remark.label': lang === 'zh' ? '备注' : 'Remark',
        'subaccount.modal.edit.remark.placeholder': lang === 'zh' ? '请输入备注' : 'Please enter remark',
        'subaccount.message.warning.incomplete': lang === 'zh' ? '请填写完整信息' : 'Please fill in complete information',
        'subaccount.message.success.add': lang === 'zh' ? '添加子账号成功' : 'Add sub account success',
        'subaccount.message.success.edit': lang === 'zh' ? '修改成功' : 'Edit success',
        'subaccount.message.success.action': lang === 'zh' ? '操作成功' : 'Action success',
        'subaccount.message.warning.invalid.flow': lang === 'zh' ? '请输入有效的流量值' : 'Please enter valid flow value',
        'subaccount.message.warning.failed.get': lang === 'zh' ? '获取子账号信息失败' : 'Failed to get sub account information',
        'subaccount.message.error.add': lang === 'zh' ? '添加子账号失败' : 'Failed to add sub account',
        'subaccount.message.error.edit': lang === 'zh' ? '编辑备注失败' : 'Failed to edit remark',
        'subaccount.message.error.deduct': lang === 'zh' ? '扣除流量失败' : 'Failed to deduct flow',
        'subaccount.message.error.add.flow': lang === 'zh' ? '添加流量失败' : 'Failed to add flow',
        'subaccount.message.error.delete': lang === 'zh' ? '删除子账号失败' : 'Failed to delete sub account',
        'subaccount.confirm.delete.title': lang === 'zh' ? '删除确认' : 'Delete Confirmation',
        'subaccount.confirm.delete.content': lang === 'zh' ? '确定要删除子账号' : 'Are you sure to delete sub account',
        'subaccount.confirm.delete.cancel': lang === 'zh' ? '取消' : 'Cancel',
        'subaccount.message.error.get.list': lang === 'zh' ? '获取子账号列表失败' : 'Failed to get sub account list',
      };
      return translations[key] || key;
    },
    // 登录状态测试
    getLoginStatus() {
      this.$request.get('/ums/isLoginStates').then((res) => {
        if (res.data.code === 5000) {
          this.$router.push('/login')
          window.localStorage.clear();
          this.$message.warning('请重新登录！');
        }
      })
      .catch((e) => {
        console.log(e);
      })
    },
    start() {
      this.timer = setInterval(this.getLoginStatus, 10000); // 第一个参数为方法名的时候不要加括号;
    },
    // 获取列表数据
    getlist() {
      this.dataLoading = true;
      this.sonFlow = 0;
      this.sonFlowCanUse = 0;
      this.$request.post('/ums/Pro/selectSonAccountList?uid='+ this.uid +'&uname='+ this.formData.uname).then((res) => {
        if (res.data.code === 200) {
          this.datalist = res.data.data;
          if(this.datalist.length > 0){
            this.datalist.forEach((item) => {
              if(item.type == "master"){
                this.masterInfo = item;
              }else{
                this.sonFlowCanUse += (Number(item.countFlow) - Number(item.consumeFlow));
                this.sonFlow += Number(item.countFlow);
              }
            });
          }
        } else {
          this.$message.error(res.data.msg || '获取子账号列表失败');
        }
      })
      .catch((e) => {
        console.error('获取子账号列表失败:', e);
        this.$message.error(this.translate('subaccount.message.error.get.list'));
      })
      .finally(() => {
        this.dataLoading = false;
      });
    },    // 获取数据类型下拉列表
    getTypelist() {
      this.$request.get('/openapi/selectDtdataType').then((res) => {
        this.dataTypeList = res.data
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        this.dataLoading = false;
      });
    },
    // 显示分配流量模态框（添加子账号）
    showAllocateModal() {
      this.visiblefp = true;
      this.resetCutflewform();
    },
    // 分配账户确认（添加子账号）
    onflewform() {
      if (!this.cutflewform.sonname || !this.cutflewform.password || !this.cutflewform.flow) {
        this.$message.warning(this.translate('subaccount.message.warning.incomplete'));
        return;
      }
      // 构建请求参数
      const params = {
        ...this.cutflewform,
        uid: localStorage.getItem('userId') || '1',
        uname: this.cutflewform.sonname,
        realyAccount: this.cutflewform.sonname
      };
      this.$request.post('/ums/addSonAcount', params).then((res) => {
        if (res.data.code === 200) {
          this.$message.success(this.translate('subaccount.message.success.add'))
          this.getlist()
          this.visiblefp = false;
          this.resetCutflewform();
        } else {
          this.$message.warning(res.data.msg || '添加失败')
        }
      })
      .catch((e) => {
        console.error('添加子账号失败:', e);
        this.$message.error(this.translate('subaccount.message.error.add'));
      })
    },
    // 重置分配流量表单
    resetCutflewform() {
      this.cutflewform = { flow: '', password: '', sonname: '', dataType: '' };
    },
    // 添加账户关闭
    onCloseform() {
      this.visiblefp = false;
      this.resetCutflewform();
    },
    // 编辑备注关闭
    onCloseEdit() {
      this.editform.remark = '';
      this.visibledit = false;
    },
    // 添加流量关闭
    onCloseflew() {
      this.addflewform.flow = '';
      this.visiblenewfp = false;
    },
    // 扣除流量关闭
    onCloseflewd() {
      this.dudflewform.flow = '';
      this.visiblenewfd = false;
    },
    // 编辑备注确认
    updateEdit() {
      // 检查nodeId和当前编辑行
      if (!this.nodeId || !this.currentEditRow) {
        this.$message.warning(this.translate('subaccount.message.warning.failed.get'));
        this.visibledit = false;
        return;
      }
      
      // 构建请求参数
      const params = {
        ...this.editform,
        nodeId: this.nodeId,
        // 添加额外标识信息，提高API调用成功率
        username: this.currentEditRow.username,
        realyAccount: this.currentEditRow.realyAccount
      };
      
      this.$request.post('/ums/updateRemark', params).then((res) => {
        if (res.data.code === 200) {
          this.$message.success(this.translate('subaccount.message.success.edit'))
          this.visibledit = false;
          this.getlist();
          this.resetEditForm();
        } else {
          this.$message.warning(res.data.msg || '修改失败')
        }
      })
      .catch((e) => {
        console.error('编辑备注失败:', e);
        this.$message.error(this.translate('subaccount.message.error.edit'));
      })
    },
    // 重置编辑表单
    resetEditForm() {
      this.editform.remark = '';
      this.nodeId = '';
      this.currentEditRow = null;
    },
    // 扣除流量确认
    dudflew() {
      if (!this.dudflewform.flow || Number(this.dudflewform.flow) <= 0) {
        this.$message.warning(this.translate('subaccount.message.warning.invalid.flow'));
        return;
      }
      this.$request.post('/ums/reduceSonFlow', {
        ...this.dudflewform,
        uid: Number(this.uid || '1'),
        upid: this.upids,
        cid: this.cids,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success(this.translate('subaccount.message.success.action'))
          this.visiblenewfd = false;
          this.getlist();
          this.dudflewform.flow = '';
        } else {
          this.$message.warning(res.data.msg || '操作失败')
        }
      })
      .catch((e) => {
        console.error('扣除流量失败:', e);
        this.$message.error(this.translate('subaccount.message.error.deduct'));
      })
    },
    // 添加流量确认
    addflew() {
      if (!this.addflewform.flow || Number(this.addflewform.flow) <= 0) {
        this.$message.warning(this.translate('subaccount.message.warning.invalid.flow'));
        return;
      }
      this.$request.post('/ums/addcumuflowClient', {
        ...this.addflewform,
        uid: Number(this.uid || '1'),
        upid: this.upids,
        cid: this.cids,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success(this.translate('subaccount.message.success.action'))
          this.visiblenewfp = false;
          this.getlist();
          this.addflewform.flow = '';
        } else {
          this.$message.warning(res.data.msg || '操作失败')
        }
      })
      .catch((e) => {
        console.error('添加流量失败:', e);
        this.$message.error(this.translate('subaccount.message.error.add.flow'));
      })
    },
    // 提交搜索
    onSubmit() {
      this.masterInfo = {
        flow: 0,
        consumeFlow: 0
      };
      this.sonFlow = 0; // 子账号总流量
      this.sonFlowCanUse = 0; // 子账号剩余流量
      this.getlist();
    },
    // 点击分配流量按钮
    rehandleClickOp(row) {
      this.uname = row.username;
      this.visiblefp = true;
      this.realyAccount = row.realyAccount;
    },
    // 点击添加流量按钮
    handleClickadd(row) {
      this.uids = row.uid;
      this.upids = row.upid;
      this.cids = row.cid;
      this.visiblenewfp = true;
    },
    // 点击扣除流量按钮
    handleClickdeduct(row) {
      this.uids = row.uid;
      this.upids = row.upid;
      this.cids = row.cid;
      this.visiblenewfd = true;
    },
    // 点击编辑备注按钮
    edit(row) {
      // 检查row对象
      console.log(row);
      if (!row) {
        this.$message.warning(this.translate('subaccount.message.warning.failed.get'));
        return;
      }
      // 显示当前备注内容
      this.editform.remark = row.remark || '';
      // 存储节点ID或用户名（作为备选）
      this.nodeId = row.nodeId || row.id || row.username;
      this.currentEditRow = row;
      this.visibledit = true;
    },
    // 点击删除按钮
    changeword(row) {
      // 检查row对象
      if (!row) {
        this.$message.warning('获取子账号信息失败');
        return;
      }
      // 使用nodeId或其他唯一标识
      const nodeId = row.nodeId || row.id || row.username;
      if (!nodeId) {
        this.$message.warning('无法获取子账号唯一标识');
        return;
      }
      // 使用Ant Design Vue 1.x的confirm正确用法
      this.$confirm({
        title: this.translate('subaccount.confirm.delete.title'),
        content: this.translate('subaccount.confirm.delete.content') + ' ' + row.username + '?',
        okType: 'danger',
        cancelText: this.translate('subaccount.confirm.delete.cancel'),
        onOk: () => {
          this.$request.delete('/ums/delectSonAccount?id=' + row.nodeId + '&sonAccountName=' + row.username + '&realyAccount=' + row.realyAccount).then((res) => {
            if (res.data.code === 200) {
              this.$message.success(this.translate('subaccount.message.success.action'))
              this.getlist();
            } else {
              this.$message.warning(res.data.msg || '删除失败')
            }
          })
          .catch((e) => {
            console.error('删除子账号失败:', e);
            this.$message.error(this.translate('subaccount.message.error.delete'));
          })
        },
        onCancel: () => {
          // 取消删除，不做任何操作
        }
      });
    },
  },
  // 清空定时器
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
};
</script>

<style scoped lang="less">
// 深色主题全局样式
.dark-theme {
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 100%);
  color: #ffffff;
  min-height: 100vh;
}

// 主容器样式
.subaccount-container {
  padding: 20px;
  // max-width: 1600px;
  margin: 0 auto;
}

// 卡片通用样式
.section-card {
  background: rgba(30, 41, 59, 0.8);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(59, 130, 246, 0.2);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  color: #ffffff !important;

  &:hover {
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.4);
    transform: translateY(-2px);
  }
}

// 卡片头部
.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(59, 130, 246, 0.2);
}

.card-icon {
  font-size: 20px;
  color: #1581c6;
  background: rgba(21, 129, 198, 0.1);
  padding: 8px;
  border-radius: 8px;
}

.card-title {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff !important;
  margin: 0;
}

// 搜索和添加区域
.search-add-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.search-form {
  flex: 1;
  min-width: 300px;
}

.add-btn-container {
  display: flex;
  align-items: center;
}

// 流量统计网格
.flow-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 20px;
  padding: 20px;
  background: rgba(21, 129, 198, 0.05);
  border: 1px solid rgba(21, 129, 198, 0.2);
  border-radius: 12px;
}

.flow-stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 16px;
  background: rgba(30, 41, 59, 0.5);
  border-radius: 8px;
  border: 1px solid rgba(59, 130, 246, 0.2);
}

.stat-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 8px;
  font-weight: 500;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #ffffff !important;
  background: linear-gradient(135deg, #1581c6 0%, #1581c6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

// 表格样式
.dark-table {
  background: transparent !important;
  color: #ffffff !important;

  :deep(.ant-table) {
    background: transparent !important;
  }

  :deep(.ant-table-thead > tr > th) {
    background: rgba(51, 65, 85, 0.8) !important;
    border-bottom: 1px solid rgba(59, 130, 246, 0.2) !important;
    color: rgba(255, 255, 255, 0.8) !important;
    font-weight: 700 !important;
    font-size: 14px;
    padding: 16px 12px;
  }

  :deep(.ant-table-tbody > tr) {
    background: transparent !important;
    border-bottom: 1px solid rgba(59, 130, 246, 0.1) !important;
  }

  :deep(.ant-table-tbody > tr > td) {
    color: rgba(255, 255, 255, 0.7) !important;
    font-size: 14px;
    padding: 16px 12px;
    background: rgba(30, 41, 59, 0.3) !important;
  }

  :deep(.ant-table-tbody > tr:hover > td) {
    background: rgba(21, 129, 198, 0.2) !important;
  }

  :deep(.ant-pagination) {
    color: rgba(255, 255, 255, 0.6) !important;
  }

  :deep(.ant-pagination-item) {
    background: rgba(51, 65, 85, 0.8) !important;
    border: 1px solid rgba(59, 130, 246, 0.3) !important;
  }

  :deep(.ant-pagination-item a) {
    color: rgba(255, 255, 255, 0.6) !important;
  }

  :deep(.ant-pagination-item-active) {
    background: linear-gradient(135deg, #1581c6 0%, #1581c6 100%) !important;
    border-color: transparent !important;
  }

  :deep(.ant-pagination-item-active a) {
    color: #ffffff !important;
  }

  :deep(.ant-empty) {
    color: rgba(255, 255, 255, 0.5) !important;
  }

  :deep(.ant-empty-description) {
    color: rgba(255, 255, 255, 0.5) !important;
  }
}

// 表单样式
.dark-form {
  color: #ffffff !important;

  :deep(.ant-form-item-label > label) {
    color: rgba(255, 255, 255, 0.9) !important;
    font-weight: 500;
  }
}

// 深色输入框
.dark-input,
:deep(.dark-input),
:deep(.ant-input),
:deep(.ant-select-selector),
:deep(.ant-select-dropdown),
:deep(.ant-modal .ant-input) {
  background: #000000 !important;
  border: 1px solid rgba(59, 130, 246, 0.5) !important;
  color: #ffffff !important;
  border-radius: 8px !important;

  &::placeholder {
    color: rgba(255, 255, 255, 0.4) !important;
  }

  &:focus {
    border-color: #1581c6 !important;
    box-shadow: 0 0 0 2px rgba(21, 129, 198, 0.2) !important;
  }
}

// 修复输入框清除按钮可见性
:deep(.ant-input-clear-icon),
:deep(.ant-input-suffix) {
  color: rgba(255, 255, 255, 0.7) !important;
  opacity: 1 !important;
  
  &:hover {
    color: #ffffff !important;
    background: rgba(21, 129, 198, 0.2) !important;
    border-radius: 50% !important;
  }
}

// 表格滚动条样式
:deep(.ant-table-body),
:deep(.ant-table-scroll .ant-table-body),
:deep(.ant-table-wrapper .ant-table-body) {
  // 滚动条轨道
  &::-webkit-scrollbar-track {
    background: #000000 !important;
    border-radius: 4px !important;
  }
  
  // 滚动条滑块
  &::-webkit-scrollbar-thumb {
    background: rgba(59, 130, 246, 0.5) !important;
    border-radius: 4px !important;
    border: 1px solid rgba(59, 130, 246, 0.3) !important;
  }
  
  // 滚动条滑块悬停
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(59, 130, 246, 0.7) !important;
  }
  
  // 滚动条宽度
  &::-webkit-scrollbar {
    width: 8px !important;
    height: 8px !important;
  }
  
  // Firefox滚动条样式
  scrollbar-width: thin !important;
  scrollbar-color: rgba(59, 130, 246, 0.5) #000000 !important;
}

// 确保textarea也应用黑色背景
:deep(.ant-input-textarea),
:deep(.ant-input-textarea textarea) {
  background: #000000 !important;
  border: 1px solid rgba(59, 130, 246, 0.5) !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.4) !important;
  }
}

// 按钮样式
.action-btn {
  background: rgba(51, 65, 85, 0.8) !important;
  border: 1px solid rgba(59, 130, 246, 0.3) !important;
  color: #ffffff !important;
  padding: 6px 20px !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  transition: all 0.3s ease !important;

  &:hover {
    background: rgba(21, 129, 198, 0.2) !important;
    border-color: #1581c6 !important;
    transform: translateY(-1px) !important;
  }
}

.generate-button {
  background: linear-gradient(135deg, #1581c6 0%, #1581c6 100%) !important;
  border: none !important;
  padding: 6px 32px !important;
  border-radius: 8px !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #ffffff !important;
  transition: all 0.3s ease !important;
  box-sizing: content-box;

  &:hover {
    transform: translateY(-2px) !important;
    box-shadow: 0 6px 20px rgba(21, 129, 198, 0.5) !important;
  }

  & span {
    color: #ffffff !important;
  }
}

// 表格按钮
.table-btn {
  padding: 4px 12px !important;
  border-radius: 6px !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  transition: all 0.2s ease !important;
  border: none !important;

  & span {
    color: #ffffff !important;
  }
}

.primary-btn {
  background: linear-gradient(135deg, #1581c6 0%, #1581c6 100%) !important;
}

.secondary-btn {
  //换一个偏红色的颜色
  background: rgba(255, 44, 0.8) !important;
  border: 1px solid rgba(59, 130, 246, 0.3) !important;
}

.danger-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
}

.info-btn {
  //换一个其他的颜色
  background: rgba(0, 102, 241, 0.8) !important;
}

// 深色模态框
.dark-modal {
  :deep(.ant-modal) {
    background: rgba(30, 41, 59, 0.95) !important;
    backdrop-filter: blur(10px) !important;
    border: 1px solid rgba(59, 130, 246, 0.3) !important;
    border-radius: 12px !important;
    color: #ffffff !important;
  }

  :deep(.ant-modal-content) {
    background: transparent !important;
    border: none !important;
    border-radius: 12px !important;
    color: #ffffff !important;
  }

  :deep(.ant-modal-header) {
    background: rgba(30, 41, 59, 0.9) !important;
    border-bottom: 1px solid rgba(59, 130, 246, 0.2) !important;
    border-radius: 12px 12px 0 0 !important;
    padding: 20px !important;
  }

  :deep(.ant-modal-title) {
    color: #ffffff !important;
    font-weight: 700 !important;
    font-size: 16px !important;
  }

  :deep(.ant-modal-body) {
    background: transparent !important;
    padding: 24px !important;
    color: #ffffff !important;
  }

  :deep(.ant-modal-footer) {
    background: rgba(30, 41, 59, 0.9) !important;
    border-top: 1px solid rgba(59, 130, 246, 0.2) !important;
    border-radius: 0 0 12px 12px !important;
    padding: 16px 24px !important;
  }

  :deep(.ant-modal-close) {
    color: rgba(255, 255, 255, 0.7) !important;

    &:hover {
      color: #ffffff !important;
      background: rgba(21, 129, 198, 0.2) !important;
    }
  }
}

// 表单样式补充
:deep(.ant-form-inline .ant-form-item) {
  margin-bottom: 0;
  margin-right: 16px;
}

:deep(.ant-space-item) {
  margin: 0;
}

// 响应式设计
@media (max-width: 768px) {
  .subaccount-container {
    padding: 16px;
  }

  .search-add-section {
    flex-direction: column;
    align-items: stretch;
  }

  .search-form {
    min-width: auto;
  }

  .flow-stats-grid {
    grid-template-columns: 1fr;
  }

  :deep(.ant-form-inline) {
    flex-direction: column;
    align-items: flex-start;
  }

  :deep(.ant-form-inline .ant-form-item) {
    margin-right: 0;
    margin-bottom: 16px;
  }

  .dark-table {
    :deep(.ant-table) {
      font-size: 12px;
    }

    :deep(.ant-table-thead > tr > th) {
      padding: 12px 8px;
    }

    :deep(.ant-table-tbody > tr > td) {
      padding: 12px 8px;
    }
  }
}
</style>